import { BadgeColor } from "sprint-common-web";

import { CloudOrderSource } from "../../listing/OrderListingItem";

export const resolveCloudOrderSourceBadgeColor = (source: CloudOrderSource): BadgeColor => {
    switch (source) {
        case CloudOrderSource.Shreq:
            return BadgeColor.LightGreen;
        case CloudOrderSource.Buzz:
            return BadgeColor.LightBlue;
        case CloudOrderSource.Sprint:
            return BadgeColor.Gray;
        default:
            return BadgeColor.Gray;
    }
};
